import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  monthLevel: {},

  calendarHeader: {
    marginBottom: theme.spacing.xs,
  },
}));
